export default __webpack_public_path__ + "static/media/visiontrak-logo-colored.165ad52b.png";